

export const projectList = [
  {
    id: 1,
    name: "랩 포인트",
    firsttext: "오프라인 매장 기반 ",
    secondtext: "소비 생활 플랫폼",
    image: "../images/projectPhoto/projectImage1.png",
    backgroundcolor: "#ffb039",
    color: "#0c0c0c",
    border: "3px solid #0c0c0c",
    borderBottom: "2px solid #0c0c0c",
    imgtop: "-90px",
    width: "100%",
  },
  {
    id: 2,
    name: "허밍노트",
    firsttext: "입작곡 음원변환",
    secondtext: "플랫폼",
    image: "../images/projectPhoto/projectImage2.png",
    backgroundcolor: "#173250",
    color: "#ffffff",
    border: "3px solid #ffffff",
    borderBottom: "2px solid #ffffff",
    imgtop: "65px",
    width: "55%",
  },
];


export default projectList;